import { BasicResult } from "../basic-result";
import { CAAudit } from "./ca-audit";

export class CAResult extends BasicResult{
    public Audit:CAAudit;
    constructor(values: Object = {}){
        super();
        Object.assign(this, values);   
    }
}